import { some, forEach } from 'lodash';
import React from 'react';

import connect from 'components/lib/connect';
import FeatureNotification from './feature_notification';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';
import FeatureNotificationTypes from 'models/agent_notification/feature_notification_types';

const ReportsAndInsightsClassroomNotification = {
  feature: FeatureNotificationTypes.REPORTS_AND_INSIGHTS_CLASSROOM,
  roleFlags: ['teamManagement'],
  key: 'rules-maintenance-classroom',
  text: <span>Reports and Insights Classroom</span>,
  subtext: <>Learn how to generate commonly tracked contact center metrics and KPIs using Gladly Reports.</>,
  url:
    ' https://gladly.zoom.us/meeting/register/tZYvdO2qrD8oEtZ_Hv3n3IFAcCuDT3-7VDrR?utm_source=gladly&utm_medium=app&utm_campaign=registration#/registration',
  urlText: 'Register',
};

const CURRENT_FEATURES = [ReportsAndInsightsClassroomNotification];

export function FeatureNotificationList({ agentPreferences }) {
  const isFeatureEnabled = useIsFeatureEnabled();

  let featureNotifications = [];
  forEach(CURRENT_FEATURES, featureProps => {
    if (shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled)) {
      featureNotifications.push(<FeatureNotification {...featureProps} />);
    }
  });

  if (!featureNotifications.length) {
    return null;
  }

  return <React.Fragment>{featureNotifications}</React.Fragment>;
}

const FeatureNotificationListContainer = connect(mapStateToProps)(FeatureNotificationList);

function mapStateToProps({ getProvider }) {
  const agentPreferences = getProvider('agentPreferences').get();

  return {
    agentPreferences,
  };
}

export function useHasFeaturesToShow(agentPreferences) {
  const isFeatureEnabled = useIsFeatureEnabled();
  return some(CURRENT_FEATURES, featureProps => {
    return shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled);
  });
}

function shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled) {
  const roleRestricted = featureProps.roleFlags && featureProps.roleFlags.length;
  const restrictedAndHasRole = some(featureProps.roleFlags, roleFlag => isFeatureEnabled(roleFlag));
  const flagRestricted = featureProps.flag;

  return (
    (!roleRestricted || restrictedAndHasRole) &&
    (!flagRestricted || isFeatureEnabled(featureProps.flag)) &&
    !agentPreferences.hasSeenFeatureNotification(featureProps.feature)
  );
}

export default FeatureNotificationListContainer;
